import { ThemeProvider } from '@mui/material'
import { Router } from './routes'
import { useTheme } from './utils/theme'
import './locale/index'
import './utils/theme/format.css'
// import { Amplify } from 'aws-amplify'
import '@aws-amplify/ui-react/styles.css';
// import {configureAws} from './utils/constants/aws-amplify'
import { ContextProvider } from './contexts/Global'
import 'dayjs/locale/es';
import {
  QueryClientProvider,
} from '@tanstack/react-query'
import { Events, queryClient } from './hooks/emitter/types'
import { useEvent } from './hooks/emitter'
import { useState } from 'react'
import { SnackbarFormat } from './utils/types/generals'
import { SnackSimple } from './components'
import { ModalState } from './pages/questionnaire/pages/detail/typing/types'
import SimpleModal from './components/modal/simpleModal'
import { useTranslation } from 'react-i18next'
import { BreadCrumbProvider } from './components/breadCrumb/context/breadCrumbContext'
// Amplify.configure(configureAws)

import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import dayjs from 'dayjs'

// Cargar los plugins
dayjs.extend(utc);
dayjs.extend(timezone);
function App() {
  const { theme, color, handleTheme } = useTheme()
  const { t } = useTranslation()
  const [snackbar, setSnackbar] = useState<SnackbarFormat>()
  const [modal, setModal] = useState<ModalState>({ open: false, title: '', description: '' })
  useEvent({ eventName: Events.snackbar, callback: (payload) => { setSnackbar(payload) } })
  useEvent({ eventName: Events.modal, callback: (payload) => { setModal(payload) } })
  useEvent({ eventName: Events.modal_close, callback: () => { closeModal() } })
  useEvent({ eventName: Events.modal_extra, callback: (payload) => { setModal(prev => ({ ...prev, ...payload })) } })

  const closeSnackbar = () => {
    setSnackbar(undefined)
  }
  const closeModal = () => {
    setModal({
      open: false,
      title: '',
      description: ''
    })
  }
  return (
    <QueryClientProvider client={queryClient}>
      <ContextProvider colors={color} handleTheme={handleTheme}>
        <ThemeProvider theme={theme}>
          <SnackSimple
            close={closeSnackbar}
            open={snackbar?.open}
            type={snackbar?.type}
            message={snackbar?.message}
          />

          <SimpleModal
            open={!!modal.open}
            close={closeModal}
            title={modal.title}
            isLoading={!!modal?.loading}
            loadingButton={!!modal?.loading}
            description={modal.description}
            cancelText={modal.cancelText ?? t('general.cancel')}
            buttonText={modal?.confirmText ?? t('general.confirm')}
            back={modal.cancel ? () => { if (modal.cancel) { modal.cancel({ close: closeModal }) } } : undefined}
            next={modal?.confirm ? () => { if (modal?.confirm) { modal?.confirm({ close: closeModal }) } } : closeModal}
          />
          <BreadCrumbProvider>
            <Router />
          </BreadCrumbProvider>
        </ThemeProvider>
      </ContextProvider>
    </QueryClientProvider>
  )
}

export default App
